/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import {
  Typography,
  Grid,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  Box,
} from '@material-ui/core';
import Link from 'components/shared/Link';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  Root: {
    padding: theme.spacing(0, 2),
    '& .MuiAccordion-root': {
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
    '& .MuiAccordionDetails-root': {
      padding: 0,
    },
    '& .MuiAccordionSummary-root': {
      padding: 0,
      cursor: 'default',
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 3, 6, 3),
      '& .MuiAccordionSummary-expandIcon': {
        display: 'none',
      },
      '& .MuiAccordionSummary-content': {
        marginTop: 0,
        marginBottom: theme.spacing(2),
      },
    },
    [theme.breakpoints.down('lg')]: {
      '& .MuiAccordionSummary-expandIcon': {
        border: '1px solid',
        borderRadius: '50%',
        padding: 0,
        marginRight: theme.spacing(2),
      },
    },
  },
  LGSLabel: {
    color: theme.palette.grey[600],
    marginBottom: theme.spacing(2.375),
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  LGSTitle: {
    color: theme.palette.secondary.dark,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(18),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  LGSCustomGrid: {
    paddingBottom: theme.spacing(2),
  },
}));

const LinksGroupSection = (props) => {
  const { linksGroup, handleLinkClick, defaultExpanded = false } = props;
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const classes = useStyles();
  const [expanded, setExpanded] = useState(isDesktop || defaultExpanded);
  const toggleAccordion = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Box className={classes.Root}>
      <Accordion expanded={isDesktop || expanded}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          id={linksGroup.title}
          onClick={toggleAccordion}
        >
          <Typography variant="h3" component="h2" className={classes.LGSTitle}>
            {linksGroup.title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            {linksGroup.linksList.map((link) => (
              <Grid
                item
                lg={4}
                md={6}
                sm={12}
                xs={12}
                key={link.id}
                className={classes.LGSCustomGrid}
              >
                <Link href={link.path} onClick={() => handleLinkClick(link.path)}>
                  <Typography variant="h6" component="span" className={classes.LGSLabel}>
                    {link.label}
                  </Typography>
                </Link>
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export { LinksGroupSection };
